if (!customElements.get("m-product-inventory")) {
  class productInventory extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        inventoryQuantity: ".m-product-inventory__quantity",
        inventoryStatus: ".m-product-inventory__status",
        inventoryMessage: ".m-product-inventory__message",
        indicatorBar: ".m-product-inventory__indicator-bar",
      };

      this.domNodes = queryDomNodes(this.selectors, this);
    }

    connectedCallback() {
      this.productId = this.dataset.productId;
      this.inventoryVisibility = this.dataset.inventoryVisibility;
      this.hideStockBackordered = this.dataset.hideStockBackordered === "true";
      this.variantInventoryData = this.readInventoryData();

      this.handleVariantChange();

      const selectedVariant = this.getSelectedVariant();
      const selectedInventory = selectedVariant ? this.getInventoryByVariantId(selectedVariant.id) : null;
      if (selectedInventory) {
        this.updateInventoryStatusForVariant(selectedInventory, selectedVariant);
      } else {
        this.updateInventoryStatus(
          parseInt(this.dataset.inventoryQuantity),
          this.dataset.variantAvailable === "true",
          this.dataset.inventoryPolicy
        );
      }
    }

    readInventoryData() {
      const script = this.querySelector('[type="application/json"]');
      if (!script) return [];
      try {
        return JSON.parse(script.textContent) || [];
      } catch (error) {
        return [];
      }
    }

    getProductData() {
      return window._themeProducts && window._themeProducts[this.productId];
    }

    getSelectedVariant() {
      const product = this.getProductData();
      return product && (product.selected_variant || product.selected_or_first_available_variant);
    }

    getVariantById(variantId) {
      const product = this.getProductData();
      const variants = product && product.variants ? product.variants : [];
      return variants.find((variant) => Number(variant.id) === Number(variantId));
    }

    getInventoryByVariantId(variantId) {
      return this.variantInventoryData.find((item) => Number(item.id) === Number(variantId));
    }

    normalizeInventoryPolicy(count, available, inventoryPolicy, variant) {
      const isUntrackedVariant =
        variant && (variant.inventory_management === null || typeof variant.inventory_management === "undefined");

      if (isUntrackedVariant && available && inventoryPolicy === "continue" && count <= 0) {
        return "deny";
      }

      return inventoryPolicy;
    }

    updateInventoryStatusForVariant(inventoryObject, variant) {
      if (!inventoryObject) {
        this.updateInventoryStatus(0, false);
        return;
      }

      const matchedVariant = variant || this.getVariantById(inventoryObject.id);
      const count = parseInt(inventoryObject.inventory_quantity);
      const inventoryPolicy = this.normalizeInventoryPolicy(
        count,
        inventoryObject.available,
        inventoryObject.inventory_policy,
        matchedVariant
      );

      this.updateInventoryStatus(count, inventoryObject.available, inventoryPolicy);
    }

    handleVariantChange() {
      window.MinimogEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, (variant) => {
        if (variant) {
          const variantInventoryObject = this.getInventoryByVariantId(variant.id);
          this.updateInventoryStatusForVariant(variantInventoryObject, variant);
        } else {
          this.updateInventoryStatus(0, false);
        }
      });
    }

    updateInventoryStatus(count, available, inventoryPolicy) {
      count = Number.isNaN(count) ? 0 : count;
      const threshold = parseInt(this.dataset.inventoryThreshold) || 0;
      let status;
      let show = false;

      if (count <= 0) {
        status = inventoryPolicy === "continue" ? "backordered" : available ? "instock" : "outofstock";
      } else if (count <= threshold) {
        status = "low";
      } else {
        status = "normal";
      }

      this.setAttribute("data-status", status);

      if (this.inventoryVisibility === "always") {
        show = true;
        if (status === "backordered" && this.hideStockBackordered) show = false;
      } else if (status === "low") {
        show = true;
      }

      if (show) {
        this.classList.remove("m:hidden");
        const inventoryText = this.getInventoryText()[status];
        this.domNodes.inventoryMessage.innerHTML = inventoryText.message;

        if (inventoryText.show_count) {
          if (inventoryText.text_html) {
            const text = inventoryText.text_html.replace("{{ quantity }}", count);
            this.domNodes.inventoryStatus.classList.remove("m:hidden");
            this.domNodes.inventoryStatus.innerHTML = text;
          } else {
            this.domNodes.inventoryStatus.innerHTML = "";
            this.domNodes.inventoryStatus.classList.add("m:hidden");
          }
        } else if (inventoryText.text) {
          this.domNodes.inventoryStatus.classList.remove("m:hidden");
          this.domNodes.inventoryStatus.innerHTML = inventoryText.text;
        } else {
          this.domNodes.inventoryStatus.innerHTML = "";
          this.domNodes.inventoryStatus.classList.add("m:hidden");
        }

        this.handleIndicatorBar(status, count);
      } else {
        this.classList.add("m:hidden");
      }
    }

    handleIndicatorBar(status, count) {
      if (this.domNodes.indicatorBar) {
        const total = this.dataset.total;
        let width;
        if (status === "backordered" || status === "outofstock") {
          width = 0;
        } else if (status !== "backordered" && (count >= total || status === "instock")) {
          width = 100;
        } else {
          width = (count / total * 100).toFixed(1);
          width = width < 5 ? 5 : width;
        }
        this.domNodes.indicatorBar.querySelector("span").style.width = `${width}%`;
      }
    }

    getInventoryText() {
      const { inStock, outOfStock, lowStock, inventoryQuantityHtml, inventoryLowQuantityHtml } = window.MinimogStrings;
      const show_count = this.dataset.showInventoryCount;
      return {
        normal: {
          text: inStock,
          text_html: inventoryQuantityHtml,
          message: this.dataset.normalText,
          show_count: show_count === "always",
        },
        instock: { text: inStock, message: this.dataset.normalText, show_count: false },
        low: {
          text: lowStock,
          text_html: inventoryLowQuantityHtml,
          message: this.dataset.lowText,
          show_count: show_count !== "never",
        },
        outofstock: { text: outOfStock, message: this.dataset.outofstockText, show_count: false },
        backordered: { text: "", message: this.dataset.backorderedText, show_count: false },
      };
    }
  }

  customElements.define("m-product-inventory", productInventory);
}
